"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dispatchNetworkRequest = exports.dispatchNetworkRequestDynamicSuccessDispatch = exports.addDispatchItems = exports.getErrorMessage = void 0;

var errorTypes = _interopRequireWildcard(require("./error/types"));

var successTypes = _interopRequireWildcard(require("./success/types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getErrorMessage = function getErrorMessage(_ref) {
  var error = _ref.error,
      defaultErrorMessage = _ref.defaultErrorMessage;

  if (typeof error === 'string') {
    return error;
  }

  if (error && error.message) {
    return error.message;
  }

  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  return defaultErrorMessage;
};

exports.getErrorMessage = getErrorMessage;

var addDispatchItems = function addDispatchItems(dispatchAction, response, responseName, successMessage) {
  var updatedDispatchAction = dispatchAction;
  updatedDispatchAction[responseName] = response;

  if (successMessage) {
    updatedDispatchAction.successType = successTypes.TEMPORARY_SUCCESS;
    updatedDispatchAction.success = successMessage;
  }

  return updatedDispatchAction;
};

exports.addDispatchItems = addDispatchItems;

var dispatchNetworkRequestDynamicSuccessDispatch = function dispatchNetworkRequestDynamicSuccessDispatch(_ref2) {
  var dispatch = _ref2.dispatch,
      requestType = _ref2.requestType,
      successDispatch = _ref2.successDispatch,
      errorType = _ref2.errorType,
      promise = _ref2.promise,
      successMessage = _ref2.successMessage,
      defaultErrorMessage = _ref2.defaultErrorMessage,
      responseName = _ref2.responseName;
  dispatch({
    type: requestType
  });
  promise.then(function (response) {
    var dispatchAction = addDispatchItems(successDispatch, response, responseName, successMessage);
    dispatch(dispatchAction);
  })["catch"](function (error) {
    return dispatch({
      type: errorType,
      errorType: errorTypes.TEMPORARY_ERROR,
      error: getErrorMessage({
        error: error,
        defaultErrorMessage: defaultErrorMessage
      })
    });
  });
};

exports.dispatchNetworkRequestDynamicSuccessDispatch = dispatchNetworkRequestDynamicSuccessDispatch;

var dispatchNetworkRequest = function dispatchNetworkRequest(_ref3) {
  var dispatch = _ref3.dispatch,
      requestType = _ref3.requestType,
      successType = _ref3.successType,
      errorType = _ref3.errorType,
      promise = _ref3.promise,
      successMessage = _ref3.successMessage,
      defaultErrorMessage = _ref3.defaultErrorMessage,
      responseName = _ref3.responseName;
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch: dispatch,
    requestType: requestType,
    successDispatch: {
      type: successType
    },
    errorType: errorType,
    promise: promise,
    successMessage: successMessage,
    defaultErrorMessage: defaultErrorMessage,
    responseName: responseName
  });
};

exports.dispatchNetworkRequest = dispatchNetworkRequest;
var _default = {
  dispatchNetworkRequest: dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch: dispatchNetworkRequestDynamicSuccessDispatch
};
exports["default"] = _default;